import { render, staticRenderFns } from "./ControlDrugAdminList.vue?vue&type=template&id=60201dec"
import script from "./ControlDrugAdminList.vue?vue&type=script&lang=js"
export * from "./ControlDrugAdminList.vue?vue&type=script&lang=js"
import style0 from "./ControlDrugAdminList.vue?vue&type=style&index=0&id=60201dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports